import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SelectAsync from 'react-select/async';

export default class CompanyUser extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            companyId: props.CompanyId,
            caller: props.Caller,
            data: null,
            loading: true,
            mobile: '',
            name: '',
            password: '',
            userGroups: [],
            annuals: []
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/company/user/get", {
            companyId: this.state.companyId,
            id: this.state.id
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        name: data.name,
                        mobile: data.mobile,
                        userGroups: data.userGroups,
                        annuals: data.annuals,
                        data: data,
                        password: '',
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        this.httpPost("api/v1/company/user/save", {
            id: this.state.id,
            mobile: this.state.mobile,
            name: this.state.name,
            password: this.state.password,
            companyId: this.state.companyId,
            userGroups: this.state.userGroups,
            annuals: this.state.annuals
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "minWidth": "60%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                افزودن کاربر جدید
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <label for="name" className="title1">نام و نام خانوادگی</label><span className="red">*</span>
                                            <input disabled={this.state.id === this.defaultGuid() ? false : true} defaultValue={this.state.name} onChange={e => this.state.name = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <label for="name" className="title1">شماره موبایل</label><span className="red">*</span>
                                            <input disabled={this.state.id === this.defaultGuid() ? false : true} defaultValue={this.state.mobile} onChange={e => this.state.mobile = e.target.value} autocomplete="off" type="text" className="form-control input-sm ltr" maxlength="11" />
                                        </div>
                                    </div>
                                    {this.state.id === this.defaultGuid() && <div className="col-sm-6">
                                        <div className="form-group">
                                            <label className="form-label">کلمه عبور</label>
                                            <input defaultValue={this.state.password} onChange={e => this.state.password = e.target.value} autoComplete="off" type="password" className="form-control ltr" maxLength="20" />
                                        </div>
                                    </div>}
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <label className="form-label">انتخاب گروه های کاربری</label>
                                            <div className="form-control-wrap">
                                                <SelectAsync
                                                    defaultValue={this.state.userGroups}
                                                    isMulti={true}
                                                    placeholder="انتخاب کنید"
                                                    defaultOptions
                                                    loadOptions={this.loadUserGroupsOptions}
                                                    onChange={e => this.setState({ userGroups: e })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <label className="form-label">سال های مالی مجاز به دسترسی</label>
                                            <SelectAsync
                                                defaultValue={this.state.annuals}
                                                isMulti={true}
                                                placeholder="انتخاب کنید"
                                                defaultOptions
                                                loadOptions={this.loadAnnualsOptions}
                                                onChange={e => this.setState({ annuals: e })}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                            <button type="submit" onClick={e => this.save(e)} className="btn btn-success">ذخیره</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}